import React from 'react'
import { Redirect } from 'react-router-dom'
import { MainAuth, SubscribedRoute } from '../layouts/Main'

const PageRedirect = () => {
  return <Redirect to="/customers" />
}

const Landing = () => {
  return (
    <MainAuth>
      <SubscribedRoute>
        <PageRedirect />
      </SubscribedRoute>
    </MainAuth>
  )
}

export default Landing
